// Graphic 3 of 4 — backend incidents first seen, per week (SERVICE_5XX +
// GRPC_BREAK cluster first-seens; recurrences don't double-count). Bars carry
// the product-defect hue: an incident IS a product-defect candidate, and the
// colour must match the chip everywhere else.
import { useState } from 'react';
import { useChart, tooltipStyle, axisStyle } from '../../lib/useChart';
import { chrome, classificationColor } from '../../lib/palette';
import { esc } from '../../lib/format';
import { weekLabel } from '../../lib/trends';
import ChartCard from '../ChartCard';

export default function IncidentBars({ series, mode }) {
  const [showTable, setShowTable] = useState(false);
  const c = chrome(mode);
  const color = classificationColor('product', mode);

  const [ref] = useChart(
    () => ({
      backgroundColor: 'transparent',
      grid: { left: 30, right: 8, top: 12, bottom: 28 },
      tooltip: {
        trigger: 'item',
        ...tooltipStyle(c),
        formatter: (p) => {
          const w = series[p.dataIndex];
          return (
            `<div style="font-weight:600;font-size:14px">${esc(w.incident_clusters)} incident${w.incident_clusters === 1 ? '' : 's'} first seen</div>` +
            `<div style="color:${c.textSecondary}">week of ${esc(weekLabel(w.week_start))}</div>`
          );
        },
      },
      xAxis: {
        type: 'category',
        data: series.map((w) => weekLabel(w.week_start)),
        ...axisStyle(c),
        axisLabel: { color: c.muted, fontSize: 10 },
        splitLine: { show: false },
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        ...axisStyle(c),
        axisLine: { show: false },
        axisLabel: { color: c.muted, fontSize: 11 },
      },
      series: [
        {
          type: 'bar',
          data: series.map((w) => w.incident_clusters),
          barMaxWidth: 22,
          itemStyle: { color, borderRadius: [3, 3, 0, 0] },
          label: {
            show: true,
            position: 'top',
            color: c.textPrimary,
            fontSize: 11,
            fontWeight: 600,
            formatter: (p) => (p.value > 0 ? p.value : ''),
          },
        },
      ],
    }),
    [series],
    { mode }
  );

  return (
    <ChartCard
      title="Backend incidents first seen, per week"
      subtitle="SERVICE_5XX + GRPC_BREAK · first-seen only, recurrences don't double-count"
      showTable={showTable}
      onToggleTable={() => setShowTable((v) => !v)}
      table={
        <table className="data-table">
          <thead>
            <tr><th>Week of</th><th className="num">Incidents first seen</th></tr>
          </thead>
          <tbody>
            {series.map((w) => (
              <tr key={w.week_start}>
                <td>{weekLabel(w.week_start)}</td>
                <td className="num">{w.incident_clusters}</td>
              </tr>
            ))}
          </tbody>
        </table>
      }
    >
      <div ref={ref} className="chart chart--half" />
    </ChartCard>
  );
}
